<template>
	<div>
		<transition>
      <div class="w-100 fixed-top" v-show="action_success.show">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
              <p class="mb-0 body-3-1">{{action_success.message}}</p>
            </div>  
          </b-col>
        </b-row>
      </div>
    </transition>
		<div class="w-100 text-center py-3 border-bottom">
			<p class="body-2 mb-1">{{$t('payment-result.payment-time')}}</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="w-100 py-3 text-center border-bottom">
			<p class="body-3 mb-1">{{$t('payment-result.payment-paid')}}</p>
			<p class="body-2-4 text-orange mb-1">{{formatCurrency(total_payment)}}</p>
			<p class="body-3 mb-0 text-green cursor-pointer" @click="copyAmount">{{$t('payment-result.copy-amount')}}</p>
		</div>
		<div class="w-100 py-3 text-center">
			<div class="w-100 mb-3 pb-3 border-bottom">
				<p class="body-2 mb-2">{{data.payment_details.payment_method_name}}</p>
				<p class="body-3 mb-0">{{$t('payment-result.virtual-account-number')}}</p>
				<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.payment_details.virtual_account_number}}</p>
				<p v-if="data.payment_details.bank_name == 'JOKUL_DOKU'" class="body-3 mb-0">{{$t('payment-result.for-payment-method')}} <a :href="data.payment_details.how_to_pay_page" class="font-weight-bold text-orange" target="_blank">{{$t('payment-result.click-here')}}</a></p>
				<div v-if="!(data.payment_details.payment_channel_description == null || data.payment_details.payment_channel_description == '')" class="mb-0 body-3-3 mt-2" v-html="data.payment_details.payment_channel_description"></div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {formatCurrency,formatDate} from '@/utils/index.js'
	import moment from 'moment';
	import axios from 'axios'

	export default{
		props:{
			data:{
				type: Object
			},
			type:{
				type: String,
				default: 'be'
			}
		},
		data(){
			return{
	      countdown: moment(),
	      timeout: false,
				action_success:{
          show: false,
          message: '',
          timer: 0
        },
        how_to_pay:{
        	jokul : {}
        },
        how_to_pay_selected:{}
			}
		},
		computed:{
			show_success(){
        return this.action_success.show
      },
      total_payment(){
      	if(this.type == 'be'){
      		return parseInt(this.data.payments.total_deposit)+parseInt(this.data.payments.payment_surcharge)
      	}else{
      		return parseInt(this.data.total_paid)
      	}
      }
		},
		watch:{
			show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
		},
		mounted() {
			let now = moment().format("YYYY-MM-DD HH:mm:ss")
			let exp = null

			if(this.data.payment_details.bank_name == 'IPAYMU'){
				let offset_time = "+07:00" //JAKARTA
				let exp_date = moment(this.data.payment_details.expired_date).format("HH:mm:ss")
				let local_tz = moment().format("Z")
				let exp_z = moment(`${exp_date}${offset_time}`,'HH:mm:ssZ').format()
	      exp = moment.parseZone(exp_z).local().format("YYYY-MM-DD HH:mm:ss")
			} else{
				now = this.data.payment_details.bank_name == 'JOKUL' ? moment().add(1,'h').format("YYYY-MM-DD HH:mm:ss") : now
	      exp = moment(this.data.payment_details.expired_date_utc).format("YYYY-MM-DD HH:mm:ss")
			}

      this.countdown = moment.duration(moment(exp).diff(moment(now)))

      let looping = setInterval(() => {
          this.countdown = this.countdown.subtract(1, 'seconds')
        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
          clearInterval(looping)
          this.timeout = true
        }
      },1000)
		},
		methods: {
			...mapGetters(['getTicketPayment']),
			formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      testConsole(){
      	console.log("payment : ", this.getTicketPayment())
      },
      showHideData(data){
      	if (this.how_to_pay_selected.channel != data.channel) {
	 				this.how_to_pay_selected = data
	 			}
      },
      copyAmount(){
        var value = this.total_payment;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = this.$t("payment-result.total-bill-copy")
        this.action_success.timer = 2
      },
      loadHowToPay(){
      	axios.defaults.headers.get['Content-Type'] ='text/plain';
      	axios.get(this.data.payment_details.how_to_pay_api).then((response,error)=>{
      		console.log("response :",response)
      		console.log("error :",error)
      		this.how_to_pay.jokul = response.data
      		this.how_to_pay_selected = response.data.payment_instruction[0]
      	})







    //   	const Http = new XMLHttpRequest();
				// Http.open("GET", this.data.payment_details.how_to_pay_api);
				// Http.send();

				// Http.onreadystatechange = (e) => {
				//   console.log(Http)
				// }
      }
		}
	}
</script>
<style scoped>
	.rotate-180{
		transform: rotate(180deg);
	}
	.tab-active{
		border-bottom: 2px solid #79a33a;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/VirtualAccountBank.vue